// extracted by mini-css-extract-plugin
export default {"windy-map":"MapContainer_windy-map__+d9Sn","leaflet-map":"MapContainer_leaflet-map__vTPmw"};